import { createAction } from 'redux-actions';
import { callApi, getEndpoint } from '../../../utils/api';

const MARKET_VOLATILITY = 'MARKET_VOLATILITY';

export default function marketVolatility(
  state = {
    isLoading: false,
    isLoaded: false,
    hasFailed: false,
    error: null,
    marketVolatility: {},
  },
  { payload, type }
) {
  switch (type) {
    case `${MARKET_VOLATILITY}_PENDING`:
      return {
        ...state,
        isLoaded: false,
        isLoading: true,
      };
    case `${MARKET_VOLATILITY}_FULFILLED`:
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
        marketVolatility: payload.body,
      };
    case `${MARKET_VOLATILITY}_REJECTED`:
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
        hasError: true,
        error: payload,
      };
    default:
      return state;
  }
}

export const getMarketVolatilityInformation = () => {
  return (dispatch) => {
    const action = createAction(MARKET_VOLATILITY)(
      callApi(getEndpoint('marketVolatility'))
    );
    dispatch(action);
  };
};
